import service from '@/middleware'

const groupApi = {
    /**
     * Datos para la tabla del ABM
     * @param {*} pageSize
     * @param {*} pageNumber
     * @param {*} headers
     * @param {*} enterpriseIds
     */
    async findAll(pageSize, pageNumber, headers, enterpriseIds) {
        const url = pageSize != null && pageNumber != null
            ? `/api/group/all?pageSize=${pageSize}&pageNumber=${pageNumber}&headers=${headers}`
            : `/api/group/all?headers=${headers}`
        const response = await service.http.post(url, enterpriseIds)
        return response
    },
    /**
     * Total de grupos para el paginador de la tabla del ABM
     * @param {*} enterpriseIds
     */
    async getTotal (enterpriseIds) {
        const result = await service.http.post(`/api/group/total`, enterpriseIds)
        return result
    },
    /**
     * Para obtener un grupo con el id enviado como param
     * @param {*} groupId
     */
    async getGroup (groupId) {
        const result = await service.http.get(`/api/group/${groupId}`)
        return result
    },
    /**
     * Para obtener los grupos con el enterpriseId enviado como parámetro
     * @param {*} enterpriseId
     */
    async getGroupsByEnterpriseId (enterpriseId) {
        const result = await service.http.get(`/api/group/by-enterprise/${enterpriseId}`)
        return result
    },
    /**
     * Para validar el nombre de un grupo
     * @param {*} name
     */
    async validateGroupName (name) {
        const result = await service.http.get(`/api/group/validate-name/${name}`)
        return result
    },
    /**
     * Para crear un nuevo grupo
     * @param {*} groupDto
     * @param {*} thingIds
     */
    async create (groupDto, thingIds) {
        const result = await service.http.post(`/api/group/create`, { groupDto, thingIds })
        return result
    },
    /**
     * Para actualizar un grupo
     * @param {*} groupDto
     * @param {*} thingIds
     */
    async update (groupDto, thingIds) {
        const result = await service.http.put(`/api/group/update`, { groupDto, thingIds })
        return result
    },
    /**
     * Para eliminar un grupo
     * @param {*} id
     */
    async deleteOne (id) {
        const result = await service.http.delete(`/api/group/${id}`)
        return result
    },
    /**
     * Eliminación múltiple
     * @param {*} ids 
     */
    async deleteMany (ids) {
        const result = await service.http.put(`/api/group/multiple-delete`, ids)
        return result
    },
}

export default groupApi
